/* unplugin-vue-components disabled */import script from "./gsjj.vue?vue&type=script&lang=ts&setup=true"
export * from "./gsjj.vue?vue&type=script&lang=ts&setup=true"

import "./gsjj.vue?vue&type=style&index=0&id=293d7796&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-293d7796"]])

export default __exports__